module.exports = __webpack_public_path__ + "static/media/logo.schooltalk.485b6d1b.png";